var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "conecta-add__base" },
    [
      _c(
        "div",
        { staticClass: "flex sm12 m12" },
        [
          _c(
            "FormFieldsContainer",
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    sm12: "",
                    md12: "",
                    layout: "",
                    wrap: "",
                    "mt-4": "",
                    "mb-2": ""
                  }
                },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm12: "", layout: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        {
                          attrs: {
                            sm12: "",
                            md12: "",
                            "px-4": "",
                            "py-2": "",
                            layout: "",
                            wrap: ""
                          }
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md3: "" } },
                            [
                              _c("DatePicker", {
                                attrs: {
                                  label: "Fecha Alta Inicio",
                                  max: _vm.now
                                },
                                model: {
                                  value: _vm.objParam.start_date,
                                  callback: function($$v) {
                                    _vm.$set(_vm.objParam, "start_date", $$v)
                                  },
                                  expression: "objParam.start_date"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md3: "" } },
                            [
                              _c("DatePicker", {
                                attrs: {
                                  label: "Fecha Alta Fin",
                                  max: _vm.now
                                },
                                model: {
                                  value: _vm.objParam.end_date,
                                  callback: function($$v) {
                                    _vm.$set(_vm.objParam, "end_date", $$v)
                                  },
                                  expression: "objParam.end_date"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Actividad de Despacho",
                                  "prepend-icon": "home_repair_service"
                                },
                                model: {
                                  value: _vm.objParam.nombre_add,
                                  callback: function($$v) {
                                    _vm.$set(_vm.objParam, "nombre_add", $$v)
                                  },
                                  expression: "objParam.nombre_add"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Nombre Alta",
                                  "prepend-icon": "home_repair_service"
                                },
                                model: {
                                  value: _vm.objParam.nombre_alta,
                                  callback: function($$v) {
                                    _vm.$set(_vm.objParam, "nombre_alta", $$v)
                                  },
                                  expression: "objParam.nombre_alta"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Nota de Venta",
                                  "prepend-icon": "fact_check"
                                },
                                model: {
                                  value: _vm.objParam.nombre_ndv,
                                  callback: function($$v) {
                                    _vm.$set(_vm.objParam, "nombre_ndv", $$v)
                                  },
                                  expression: "objParam.nombre_ndv"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md3: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: "Técnico",
                                  items: _vm.filterApi.tecnicos,
                                  "item-text": "nombre_tecnico",
                                  "item-value": "nombre_tecnico",
                                  clearable: "",
                                  "prepend-icon": "person"
                                },
                                model: {
                                  value: _vm.objParam.nombre_tecnico,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.objParam,
                                      "nombre_tecnico",
                                      $$v
                                    )
                                  },
                                  expression: "objParam.nombre_tecnico"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md3: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: "Estado en Conecta",
                                  items: _vm.filterApi.estados,
                                  "item-text": "configvalor",
                                  "item-value": "configid",
                                  clearable: "",
                                  "prepend-icon": "filter_list"
                                },
                                model: {
                                  value: _vm.objParam.configid,
                                  callback: function($$v) {
                                    _vm.$set(_vm.objParam, "configid", $$v)
                                  },
                                  expression: "objParam.configid"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm6: "",
                                md3: "",
                                layout: "",
                                "justify-center": "",
                                wrap: "",
                                "mt-2": ""
                              }
                            },
                            [
                              _c(
                                "v-btn",
                                { on: { click: _vm.handleSearchFilter } },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "#27488e" } },
                                    [_vm._v("search")]
                                  ),
                                  _vm._v("Filtrar\n              ")
                                ],
                                1
                              ),
                              _c(
                                "v-btn",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.reloadGrid({ clear: true })
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "#27488e" } },
                                    [_vm._v("clear")]
                                  ),
                                  _vm._v("Limpiar\n              ")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-flex",
            {
              attrs: {
                sm12: "",
                md12: "",
                layout: "",
                "justify-end": "",
                "align-center": "",
                "mt-3": "",
                "mb-4": ""
              }
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { flat: "", small: "", color: "primary" },
                  on: { click: _vm.getCSV }
                },
                [
                  _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                    _vm._v("cloud_download")
                  ]),
                  _vm._v("\n          \n        "),
                  _c("span", { staticClass: "importExportBtnTexto" }, [
                    _vm._v("Exportar"),
                    _c("br"),
                    _vm._v("CSV")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-flex",
            {
              attrs: {
                xs12: "",
                sm12: "",
                md12: "",
                "conecta-add__base_scroll": ""
              }
            },
            [
              _c("MantenedorGridSinCodigo", {
                attrs: {
                  "grid-options": _vm.gridOptions,
                  funcionalidadId: _vm.funcionalidad
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.showModalViewDetail
        ? _c("AddModalVerDetalle", {
            attrs: { data: _vm.data },
            on: { cerrar: _vm.handleClosedModal }
          })
        : _vm._e(),
      _vm.showModalDevices
        ? _c("AddModalAgregarEquipos", {
            attrs: { data: _vm.data, dialog: true },
            on: { cerrar: _vm.handleClosedModal }
          })
        : _vm._e(),
      _vm.showModalReception
        ? _c("AddModalGenerarRecepcion", {
            attrs: { data: _vm.data, dialog: true },
            on: { cerrar: _vm.handleClosedModal }
          })
        : _vm._e(),
      _vm.dialogGenerarMovimiento
        ? _c("AddGenerarMovimiento", {
            attrs: { data: _vm.data, show: _vm.dialogGenerarMovimiento },
            on: { cerrar: _vm.handleClosedModal }
          })
        : _vm._e(),
      _vm.dialogGenerarEncomienda
        ? _c("AddGenerarEncomienda", {
            attrs: { data: _vm.data, show: _vm.dialogGenerarEncomienda },
            on: { cerrar: _vm.handleClosedModal }
          })
        : _vm._e(),
      _vm.showModalGestionarDespacho
        ? _c("AddModalGestionarDespacho", {
            attrs: { data: _vm.data, dialog: true },
            on: { cerrar: _vm.handleClosedModal }
          })
        : _vm._e(),
      _vm.showPopUpReport
        ? _c("PopUpGeneratedReports", {
            attrs: { text: _vm.msgReport },
            on: { cerrar: _vm.handleCloseReport }
          })
        : _vm._e(),
      _vm.showModalNDV
        ? _c("NDVModalTabs", {
            attrs: { data: _vm.data },
            on: { cerrar: _vm.handleClosedModal }
          })
        : _vm._e(),
      _vm.showModalAltas
        ? _c("ModalVerDetalleCrm", {
            attrs: {
              show: _vm.showModalAltas,
              AltaCrm_Seleccionada: _vm.AltaCrm_Seleccionada,
              NombreAlta: _vm.NombreAlta
            },
            on: { cerrar: _vm.handleClosedModal }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }